export default {
  body: 400,
  heading: 400,
  bold: 700
}
